<div *ngIf="paginationInfo" class="listing-pagination" [ngClass]="{ tna: renderType === 'TNA' }">
  <span class="machine-number">
    {{
      paginationInfo.totalItems < paginationInfo.rangeInPage.start
        ? paginationInfo.totalItems
        : paginationInfo.rangeInPage.start
    }}
    {{ 'listing_pagination.to' | translate }}
    {{
      paginationInfo.totalItems < paginationInfo.rangeInPage.end
        ? paginationInfo.totalItems
        : paginationInfo.rangeInPage.end
    }}
    {{ 'listing_pagination.of' | translate }}
    {{ paginationInfo.totalItems }} {{ listItemsDisplayVal }}
  </span>
  <span class="page-items">
    <span>{{ 'listing_pagination.ItemsPerPage' | translate }}: </span>

    <ion-button class="dropdown-button" fill="clear" color="dark" (click)="openItemsPerPageList($event)">
      {{ userPaginationOption.pageSize }}
      <ion-icon
        [name]="isItemsPerPgeCountDropdownOpen ? 'caret-up-outline' : 'caret-down-outline'"
        class="dropdown-icon"
      ></ion-icon>
    </ion-button>
  </span>
  <span>
    <span>{{ 'listing_pagination.Page' | translate }}: </span>
    <ion-button class="dropdown-button" fill="clear" color="dark" (click)="openPageCount($event)">
      {{ this.userPaginationOption.pageNo }}
      <ion-icon
        [name]="isPageCountDropdownOpen ? 'caret-up-outline' : 'caret-down-outline'"
        class="dropdown-icon"
      ></ion-icon>
    </ion-button>
  </span>
</div>
